import {
  UPDATE_CANVAS_VALUES,
  SET_CANVAS_INITED
} from '../types/canvas.types'

export const updateCanvasValues = (data) => ({ type: UPDATE_CANVAS_VALUES, payload: data })
export const setCanvasInited = (data) => ({ type:  SET_CANVAS_INITED, payload: data })
